<template>
  <cst-page-template>
    <pcqm-dashboard-warning-container />
    <div class="container">
      <div class="container-body">
        <establishment-list />
      </div>
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import EstablishmentList from '@/components/generic/presentational/organisms/establishmentList/EstablishmentList.vue'
import PcqmDashboardWarningContainer from '@/components/generic/presentational/molecules/pcqmDashboardWarningContainer/PcqmDashboardWarningContainer.vue'
import { mapState } from 'vuex'

export default {
  components: {
    EstablishmentList,
    CstPageTemplate,
    PcqmDashboardWarningContainer,
  },
  computed: {
    ...mapState('establishments', ['establishments']),
    ...mapState('user', ['dealerId']),
  },
  watch: {
    establishments(newEstablishments, oldEstablishments) {
      if (newEstablishments != null && newEstablishments.length == 0) {
        this.$router.push({
          name: 'purchase-orders-page',
          params: {
            establishmentId: this.dealerId,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  @include center;
  display: flex;
  row-gap: 20px;
  padding-top: 2.5rem;
  justify-content: center;
  align-content: center;
}

.container-body {
  width: 80%;
}
</style>
